import React from 'react';
import { tokens } from '../theme';

type Status =
  | 'draft'
  | 'awaiting_deposit'
  | 'awaiting_activation'
  | 'active'
  | 'completed'
  | 'paid'
  | 'rejected'
  | 'payment_blocked'
  | 'pending'
  | 'approved';

const map: Record<Status, { bg: string; fg: string; border: string; label: string }> = {
  draft: { bg: 'transparent', fg: tokens.color.ink[700], border: tokens.color.ink[300], label: 'Draft' },
  awaiting_deposit: { bg: 'transparent', fg: tokens.color.accent.tan, border: tokens.color.accent.tan, label: 'Awaiting deposit' },
  awaiting_activation: { bg: 'transparent', fg: tokens.color.accent.tan, border: tokens.color.accent.tan, label: 'Funded, awaiting activation' },
  active: { bg: tokens.color.accent.sage, fg: '#fff', border: tokens.color.accent.sage, label: 'Active' },
  completed: { bg: tokens.color.ink[700], fg: '#fff', border: tokens.color.ink[700], label: 'Completed' },
  paid: { bg: tokens.color.ink[900], fg: '#fff', border: tokens.color.ink[900], label: 'Paid' },
  rejected: { bg: 'transparent', fg: tokens.color.accent.rust, border: tokens.color.accent.rust, label: 'Rejected' },
  payment_blocked: { bg: tokens.color.accent.rust, fg: '#fff', border: tokens.color.accent.rust, label: 'Payment blocked' },
  pending: { bg: 'transparent', fg: tokens.color.ink[500], border: tokens.color.ink[300], label: 'Pending' },
  approved: { bg: tokens.color.accent.sage, fg: '#fff', border: tokens.color.accent.sage, label: 'Approved' },
};

export function Badge({ status, children }: { status: Status; children?: React.ReactNode }) {
  const s = map[status] ?? map.draft;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 28,
        padding: '0 12px',
        borderRadius: tokens.radius.pill,
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        background: s.bg,
        color: s.fg,
        border: `1px solid ${s.border}`,
      }}
    >
      {children ?? s.label}
    </span>
  );
}
